/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 10:40:36
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 17:32:05
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentEditPage/index.tsx
 */

import { Skeleton } from '@/src/components/Antd';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import {
  getPaymentGatewayDetail,
  newPaymentGateway,
  paymentGatewayNameUsed,
  savePaymentGateway,
} from '@/src/request/settings/paymentGateway';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { getParameter } from '@/src/tools/helper';
import {
  AmountLimitVOAmountLimitVO,
  SalesChannelPaymentMethodVO,
  StoreGatewayProviderVO,
  paymentGatewayProvider,
} from '@/src/types/common/paymentGateway';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Form, message } from 'antd';
import { get, set, cloneDeep } from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Webhooks from '../../Components/Webhooks';
import AvailableMethods from './AvailableMethods';
import PaymentAmountLimitation from './PaymentAmountLimitation';
import PaymentGateway from './PaymentGateway';
import { breadcrumbData, dynamicSuffixValues } from './config';
import Icon from './PaymentIcon';
import { FPS_IDTYPE } from '../PaymentEditPage/constant';

const permissions = () => {
  const add_edit_payment_gateway = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsPayment,
        operation: EnumOperation.add_edit_payment_gateway,
      }),
    ],
  });
  const view_payment_gateway_details = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsPayment,
        operation: EnumOperation.view_payment_gateway_details,
      }),
    ],
  });
  const copy_webhook = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsPayment,
        operation: EnumOperation.copy_webhook,
      }),
    ],
  });
  return {
    add_edit_payment_gateway,
    view_payment_gateway_details,
    copy_webhook,
  };
};
const PaymentEditPage = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    add_edit_payment_gateway,
    view_payment_gateway_details,
    copy_webhook,
  } = permissions();
  const [form] = Form.useForm();
  const params: any = useParams();
  const { gatewayProviderCode, uuid } = params;
  const isBankTransfer = paymentGatewayProvider.BANK_TRANSFER;
  const history = useHistory();
  const location = getParameter('length');
  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(isBankTransfer ? true : false);
  const [amountLimit, setAmountLimit] = useState<AmountLimitVOAmountLimitVO[]>(
    [],
  );
  const [salesChannelPaymentMethods, setSalesChannelPaymentMethods] = useState<
    SalesChannelPaymentMethodVO[]
  >([]);
  const [editData, setEditData] = useState<StoreGatewayProviderVO>(
    {} as StoreGatewayProviderVO,
  );

  const {
    qfCode = '',
    qfKey = '',
    qfURL = '',
    publishableKey = '',
    secreteKey = '',
    signingKey = '',
    userName = '',
    password = '',
    paymentURI = '',
    paymentInstruction = '',
    merchantAccount = '',
    merchantID = '',
    clientKey = '',
    apiKey = '',
    hmacKey = '',
    urlPrefix = '',
    receivingBankCode = '',
    receivingCurrency = '',
    receivingId = '',
    receivingIdType = '',
    merchantId = '',
    apiV3Key = '',
    merchantApiSerialNumber = '',
    wechatPayPublicKeyId = '',
    merchantApiPrivateKey = '',
    wechatPayPublicKey = '',
    merchantSerialNumber = '',
  } = (editData.configFields as any) || ({} as any);

  const formatConfigFields = (gatewayProviderCode, values) => {
    const {
      qfCode,
      qfKey,
      qfURL,
      publishableKey,
      secreteKey,
      signingKey,
      userName,
      password,
      paymentURI,
      paymentInstruction,
      merchantAccount,
      merchantID,
      clientKey,
      hmacKey,
      urlPrefix,
      apiKey,
      receivingBankCode,
      receivingCurrency,
      receivingIdType,
      merchantId,
      apiV3Key,
      merchantApiPrivateKey,
      merchantApiSerialNumber,
      wechatPayPublicKey,
      wechatPayPublicKeyId,
      merchantSerialNumber,
    } = values || {};
    let data = {} as any;
    switch (gatewayProviderCode) {
      case paymentGatewayProvider.STRIPE:
        data = {
          gatewayProviderCode,
          publishableKey,
          secreteKey,
          signingKey,
        };
        break;
      case paymentGatewayProvider.ADYEN:
        data = {
          gatewayProviderCode,
          merchantAccount,
          merchantID,
          clientKey,
          hmacKey,
          urlPrefix,
          apiKey,
        };
        break;
      case paymentGatewayProvider.BANK_TRANSFER:
        data = {
          gatewayProviderCode,
          paymentInstruction,
        };
        break;
      case paymentGatewayProvider.ATOME:
        data = {
          gatewayProviderCode,
          userName,
          password,
          paymentURI,
        };
        break;
      case paymentGatewayProvider.FPS_QR_CODE:
        data = {
          gatewayProviderCode,
          receivingBankCode,
          receivingCurrency,
          receivingId:
            values?.receivingIdType === FPS_IDTYPE.FPSMOBILE &&
            values?.receivingId
              ? `+852-${values.receivingId}`
              : values?.receivingId,
          receivingIdType,
        };
        break;
      case paymentGatewayProvider.WECHAT_PAY:
        data = {
          gatewayProviderCode,
          merchantId,
          apiV3Key,
          merchantApiPrivateKey,
          merchantApiSerialNumber,
          wechatPayPublicKey,
          wechatPayPublicKeyId,
          merchantSerialNumber,
        };
        break;
      default:
        data = { gatewayProviderCode, qfCode, qfKey, qfURL };
    }
    return data;
  };

  const onFinish = (values) => {
    const icon = get(values, 'icon');
    paymentGatewayNameUsed({
      content: values.name,
      uuid: uuid,
    }).then((data) => {
      if (!data) {
        const configFields = formatConfigFields(gatewayProviderCode, values);
        const salesChannelPaymentMethodsCopy = cloneDeep(
          salesChannelPaymentMethods,
        );
        if (get(icon, 'uuid')) {
          set(salesChannelPaymentMethodsCopy, '0.paymentMethod.icons', [icon]);
        } else {
          set(salesChannelPaymentMethodsCopy, '0.paymentMethod.icons', []);
        }
        const data = {
          ...values,
          uuid,
          configFields,
          amountLimit,
          gatewayProviderCode,
          salesChannelPaymentMethods: salesChannelPaymentMethodsCopy,
        };
        savePaymentGateway(data)
          .then(() => {
            setHasModified(false);
            message.success(getI18n('general.savesuccess'));
          })
          .then(() => {
            history.push('/settings/payment/list');
          });
      } else {
        form.setFields([
          {
            errors: [getI18n('storePayment.paymentEditPage.validNameError')],
            name: ['name'],
          },
        ]);
      }
    });
  };
  const handleAmountLimitChange = (data) => {
    setAmountLimit(data);
    setHasModified(true);
  };

  const handleProcessingFeeChange = (uuid, item) => {
    const data = salesChannelPaymentMethods.map((list) => {
      if (uuid == get(list, 'paymentMethod.uuid', '')) {
        return { ...list, ...item };
      } else {
        return list;
      }
    });
    setSalesChannelPaymentMethods(data);
    setHasModified(true);
  };

  const child = [
    {
      child: (
        <PaymentGateway
          gatewayProviderIcon={editData?.gatewayProviderIcon}
          gatewayName={editData?.gatewayProviderName}
          form={form}
          disabled={!view_payment_gateway_details}
          disableEdit={!add_edit_payment_gateway}
        />
      ),
    },
    gatewayProviderCode !== paymentGatewayProvider.BANK_TRANSFER &&
      gatewayProviderCode !== paymentGatewayProvider.FPS_QR_CODE && {
        child: (
          <Webhooks
            url={(editData?.webHooks && editData.webHooks[0]) || ''}
            text={
              gatewayProviderCode === paymentGatewayProvider.WECHAT_PAY
                ? getI18n('storePayment.paymentEditPage.wechatWebhooksText')
                : getI18n('storePayment.paymentEditPage.webhooksText')
            }
            link='/'
            linkText={getI18n('storePayment.paymentEditPage.webhooksLinkText')}
            disabled={!view_payment_gateway_details}
            disableCopy={!copy_webhook}
          />
        ),
      },
    {
      child: (
        <PaymentAmountLimitation
          Limitations={amountLimit || []}
          supportedCurrencyCodes={editData?.supportedCurrencyCodes}
          handleAmountLimitChange={handleAmountLimitChange}
          disabled={!view_payment_gateway_details}
        />
      ),
    },
    {
      child: (
        <AvailableMethods
          methods={salesChannelPaymentMethods}
          processingFeeChange={handleProcessingFeeChange}
          disabled={!view_payment_gateway_details}
        />
      ),
    },
    gatewayProviderCode === paymentGatewayProvider.BANK_TRANSFER && {
      child: <Icon disabled={!view_payment_gateway_details} />,
    },
  ];

  useEffect(() => {
    if (!uuid) {
      if (add_edit_payment_gateway) {
        newPaymentGateway(gatewayProviderCode).then(
          (data: StoreGatewayProviderVO) => {
            const {
              amountLimit = [],
              salesChannelPaymentMethods = [],
              ...rest
            } = data;

            setAmountLimit(amountLimit);
            setSalesChannelPaymentMethods(salesChannelPaymentMethods);
            setEditData(rest);
            const icon = get(
              salesChannelPaymentMethods,
              '0.paymentMethod.icons.0',
            );
            form.setFieldsValue({
              icon,
            });
            setLoading(false);
          },
        );
      } else {
        setLoading(false);
      }
    } else {
      if (view_payment_gateway_details) {
        getPaymentGatewayDetail(uuid).then((data: StoreGatewayProviderVO) => {
          const {
            amountLimit = [],
            salesChannelPaymentMethods = [],
            ...rest
          } = data;
          setAmountLimit(amountLimit);
          setSalesChannelPaymentMethods(salesChannelPaymentMethods);
          const icon = get(
            salesChannelPaymentMethods,
            '0.paymentMethod.icons.0',
          );
          form.setFieldsValue({
            icon,
          });
          setEditData(rest);
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    }
  }, []);

  const goBackToList = () => {
    history.push({
      pathname: '/settings/payment/list',
    });
  };

  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData(editData?.name, { getI18n })}
    />
  );

  const topRight = (
    <TopRight
      onDiscard={goBackToList}
      onSubmit={() => {
        form.submit();
      }}
      onSaveDisable={!hasModified}
    />
  );
  const onValuesChange = () => {
    setHasModified(true);
  };

  return (
    <Fragment>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.leave')}
        active={hasModified}
        title={getI18n('general.unsavedchanges')}
        content={getI18n('general.leavePage')}
      />

      <Skeleton loading={loading} active>
        <Form
          initialValues={{
            ...editData,
            name:
              editData?.name || `${editData?.gatewayProviderName} ${location}`,
            dynamicSuffix:
              editData?.dynamicSuffix || dynamicSuffixValues.OrderNumber,
            qfCode,
            qfKey,
            qfURL,
            publishableKey,
            secreteKey,
            signingKey,
            userName,
            password,
            paymentURI,
            paymentInstruction,
            merchantAccount,
            merchantID,
            clientKey,
            hmacKey,
            apiKey,
            urlPrefix,
            receivingBankCode,
            receivingCurrency,
            receivingId:
              receivingIdType === FPS_IDTYPE.FPSMOBILE && receivingId
                ? receivingId.replace(/^\+852-/, '')
                : receivingId,

            receivingIdType,
            merchantId,
            apiV3Key,
            merchantApiPrivateKey,
            merchantApiSerialNumber,
            wechatPayPublicKey,
            wechatPayPublicKeyId,
            merchantSerialNumber,
          }}
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          hideRequiredMark
          form={form}
          name='PaymentEditPage'
          scrollToFirstError>
          <Layout
            elements={child}
            topLeft={topLeft}
            topRight={topRight}></Layout>
        </Form>
      </Skeleton>
    </Fragment>
  );
};
export default PaymentEditPage;
